// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -5rem, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInDown {
  animation-name: fadeInDown;
}
`, "",{"version":3,"sources":["webpack://./resources/assets/js/scss/custom-animate/fading_entrances/fadeInDown.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -5rem, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInDown {\n  animation-name: fadeInDown;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
